import { Component } from "react";
import Button from "react-bootstrap/Button";
import { isChunkLoadError } from "../Util/lazyWithRetry.js";
import { track } from "../Util/analytics.js";

// Catches render errors under the route Suspense so a failed lazy chunk (or a
// crashing page) shows a recoverable card instead of white-screening the app.
// RoutesTree keys this by pathname, so navigating elsewhere resets it.
export default class ChunkErrorBoundary extends Component {
    state = { error: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error("Route failed to render:", error, info?.componentStack);
        track("js_error", `Render: ${error?.message || error}`);
    }

    render() {
        const { error } = this.state;
        if (!error) return this.props.children;

        const chunkError = isChunkLoadError(error);

        return (
            <div
                role="alert"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "60vh",
                    padding: "16px",
                }}
            >
                <div className="card shadow-sm" style={{ maxWidth: 480, width: "100%" }}>
                    <div className="card-body">
                        <h5 className="card-title">
                            {chunkError ? "This page failed to load" : "Something went wrong"}
                        </h5>
                        <p className="card-text text-muted mb-2">
                            {chunkError
                                ? "Part of the app couldn't be downloaded. This is usually a stale browser cache, a network hiccup, or antivirus / proxy software interfering with the connection."
                                : "An unexpected error occurred while showing this page."}
                        </p>
                        {chunkError && (
                            <p className="card-text small text-muted">
                                If reloading doesn't help, clear this browser's cached files
                                (Ctrl+Shift+Delete → "Cached images and files") or try another browser.
                            </p>
                        )}
                        <div className="d-flex gap-2">
                            <Button variant="primary" onClick={() => window.location.reload()}>
                                Reload
                            </Button>
                            <Button variant="outline-secondary" onClick={() => window.history.back()}>
                                Go back
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
